export default "__VITE_ASSET__60a05bb0__"